import { render } from "./shipperForm.vue?vue&type=template&id=95311b72&scoped=true"
import script from "./shipperForm.vue?vue&type=script&lang=js"
export * from "./shipperForm.vue?vue&type=script&lang=js"

import "./shipperForm.vue?vue&type=style&index=0&id=95311b72&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95311b72"]])

export default __exports__